import { FieldValues, UseControllerReturn } from 'react-hook-form';

type MakeUncontrolledPropsArgs<T extends FieldValues, UncontrollablePropsT> = {
  renderProps: UseControllerReturn<T>;
  componentProps: UncontrollablePropsT;
  onChange?: (event, ...rest) => void;
  passError?: boolean;
};

export const makeUncontrolledProps = <T extends FieldValues, UncontrollablePropsT>({
  renderProps: controllerProps,
  componentProps,
  onChange,
  passError,
}: MakeUncontrolledPropsArgs<T, UncontrollablePropsT>) => {
  const {
    field: { onChange: onFieldChange, ref, ...field },
    fieldState: { error },
  } = controllerProps;
  return {
    onChange: (event) => {
      onChange && onChange(event);
      onFieldChange(event);
    },
    ...(passError ? { errorMessage: error?.message } : {}),
    ...field,
    ...componentProps,
  };
};
